import { minAbbrNumberFilter } from "app/filters/ngFilters";

export const percentDataFormat = "%";
export const numbersDataFormat = "#";
export const dataModeMap = {
    [percentDataFormat]: "percent",
    [numbersDataFormat]: "number",
    percent: "percent",
    number: "number",
} as const;

export enum EdataFormatIndex {
    PERCENT,
    NUMBERS,
}
export type DataFormat = keyof typeof dataModeMap;
export type DataMode = (typeof dataModeMap)[DataFormat];

export const numbersFilter = (val) => minAbbrNumberFilter()(val);
export const percentsFilter = (val) => (Math.round(val * 100) / 100).toFixed(2) + percentDataFormat;
